import React, { useContext } from 'react';
import GameConfigContext, { TileProps } from '../../../contexts/GameConfigContext/GameConfigContext';
import Tile from '../Tile/Tile';
import { BoardBox } from './Board.css';

const Board = (): JSX.Element => {
  const { gameConfig } = useContext(GameConfigContext);
  return (
    <BoardBox width={gameConfig.tileBoardWidth} height={gameConfig.tileBoardHeight}>
      {gameConfig.tiles.length > 0 &&
        gameConfig.tiles.map((tileArr: TileProps[], x: number) =>
          tileArr.map((tile: TileProps, y: number) => <Tile key={`tile-${x}-${y}`} {...{...tile, x, y}} />)
        )
      }
    </BoardBox>
  );
};

export default Board;
